export const RANGE = {
  MIN_VALUE: 0,
  MAX_VALUE: 50,
};



// WEBPACK FOOTER //
// ./src/views/constsnts/mdnStableRange.js